import { render, staticRenderFns } from "./BrandMaison.vue?vue&type=template&id=953773ce&scoped=true&"
import script from "./BrandMaison.vue?vue&type=script&lang=js&"
export * from "./BrandMaison.vue?vue&type=script&lang=js&"
import style0 from "./BrandMaison.vue?vue&type=style&index=0&id=953773ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953773ce",
  null
  
)

export default component.exports